export default function TrustSection() {
  return (
    <section className="py-20 px-8 lg:px-16 bg-base-200">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Your Data is Safe With Us
          </h2>
        </div>

        {/* Certifications */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-12">
          {/* ISO 27001:2022 */}
          <div className="flex flex-col items-center text-center">
            <div className="w-32 h-32 rounded-full border-4 border-primary flex flex-col items-center justify-center mb-4 bg-base-100">
              <span className="text-sm font-bold text-primary">ISO</span>
              <span className="text-sm font-bold text-primary">27001:2022</span>
              <span className="text-[10px] opacity-60 mt-1">CERTIFIED</span>
            </div>
            <p className="text-sm opacity-70 max-w-xs">
              Globally recognized standard for information security management
            </p>
          </div>

          {/* SOC 2 Type II */}
          <div className="flex flex-col items-center text-center">
            <div className="w-32 h-32 rounded-full border-4 border-primary flex flex-col items-center justify-center mb-4 bg-base-100">
              <span className="text-sm font-bold text-primary">SOC 2</span>
              <span className="text-sm font-bold text-primary">TYPE II</span>
              <span className="text-[10px] opacity-60 mt-1">COMPLIANT</span>
            </div>
            <p className="text-sm opacity-70 max-w-xs">
              Audited for security, availability, and confidentiality by independent experts
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
